import { canAccessAdminFeatures } from '../../../../utils/authPermissions';

const canViewForecastDetails = (auth) => {
    return canAccessAdminFeatures(auth);
};

export default canViewForecastDetails;
